/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskWorkflowItemConfigurationTargetingOneOf3
 */
export interface TaskWorkflowItemConfigurationTargetingOneOf3 {
    /**
     * 
     */
    target_type?: TaskWorkflowItemConfigurationTargetingOneOf3TargetTypeEnum;
    /**
     * 
     */
    facility_ids?: Array<any>;
    /**
     * 
     */
    facility_system_tags?: Array<any>;
    /**
     * 
     */
    facility_custom_tag_ids?: Array<any>;
}


/**
 * @export
 */
export const TaskWorkflowItemConfigurationTargetingOneOf3TargetTypeEnum = {
    CustomTag: 'CUSTOM_TAG',
} as const;
export type TaskWorkflowItemConfigurationTargetingOneOf3TargetTypeEnum = typeof TaskWorkflowItemConfigurationTargetingOneOf3TargetTypeEnum[keyof typeof TaskWorkflowItemConfigurationTargetingOneOf3TargetTypeEnum];


/**
 * Check if a given object implements the TaskWorkflowItemConfigurationTargetingOneOf3 interface.
 */
export function instanceOfTaskWorkflowItemConfigurationTargetingOneOf3(value: object): value is TaskWorkflowItemConfigurationTargetingOneOf3 {
    return true;
}

export function TaskWorkflowItemConfigurationTargetingOneOf3FromJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf3 {
    return TaskWorkflowItemConfigurationTargetingOneOf3FromJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOf3FromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemConfigurationTargetingOneOf3 {
    if (json == null) {
        return json;
    }
    return {
        
        'target_type': json['target_type'] == null ? undefined : json['target_type'],
        'facility_ids': json['facility_ids'] == null ? undefined : json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'] == null ? undefined : json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'] == null ? undefined : json['facility_custom_tag_ids'],
    };
}

export function TaskWorkflowItemConfigurationTargetingOneOf3ToJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf3 {
    return TaskWorkflowItemConfigurationTargetingOneOf3ToJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOf3ToJSONTyped(value?: TaskWorkflowItemConfigurationTargetingOneOf3 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_type': value['target_type'],
        'facility_ids': value['facility_ids'],
        'facility_system_tags': value['facility_system_tags'],
        'facility_custom_tag_ids': value['facility_custom_tag_ids'],
    };
}

